<template>
  <div class="search-form__grid-item search-form__sort">
    <div class="select select_search-form__select" :class="{'expanded': isExpanded}">
      <select
          name="form[]"
          class="search-form__select"
          data-default="1"
          style="display: none;"
      >
        <option
            v-for="item in options"
            :value="item.value"
            :selected="item.value === modelValue"
        >
          {{ item.title }}
        </option>
      </select>
      <div class="select__item">
        <div class="select__title">
          <div
            class="select__value"
            @click.prevent="onSelectClick">
            <span v-html="selectedItemTitle"></span>
          </div>
        </div>
        <div class="select__options" ref="selectOptions">
          <div
            v-if="canClearSelection"
            :data-value="''"
            class="select__option select__option__clear-selection"
            :class="{'_hidden': modelValue === ''}"
            @click.prevent="onSelectOptionClick({value: ''})"
          >
          Clear selection
          </div>
          <div
              v-for="item in options"
              :data-value="item.value"
              class="select__option"
              :class="{'_hidden': item.value === modelValue}"
              @click.prevent="onSelectOptionClick(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
    <div class="select select_search-form__select"></div>
  </div>
</template>

<script>
import {_slideToggle} from '@/assets/js/files/functions';

export default {
    name: "SearchFormSort",

    emits: ['update:modelValue'],

    props: {
        options: {
            required: true,
            type: Array,
            canClearSelection: false,
        },
        modelValue: String
    },

    data() {
        return {
            isExpanded: false,
        }
    },

    computed: {
        selectedItemTitle() {
            let title = 'Sort by';
            this.options.forEach((item) => {
                if (item.value === this.modelValue) {
                    title = `Sort by: ${item.title}`;
                }
            });
            return title;
        }
    },

    methods: {
        toggleSelectOptions(speed) {
            this.isExpanded = !this.isExpanded;
            speed = speed || 100;
            _slideToggle(this.$refs.selectOptions, speed);
        },

        onSelectClick() {
            this.toggleSelectOptions();
        },

        onSelectOptionClick(item) {
            this.toggleSelectOptions();
            this.$emit('update:modelValue', item.value);
        },
    }
}
</script>

<style scoped>
._hidden {
    display: none;
}
</style>